import React, { useCallback } from 'react'

import { Container, CompareUrineCulture } from './styles'
import { FilterByOrganisms } from '../FilterByOrganisms'
import { CalendarFilter, MedicalViewSelector } from '~/components/shared/medicalViews'
import { useLaboratoryHealthProcedures } from '~/context'
import { EMedicalViews } from '~/interfaces'
import { Inline } from '~/styles'

export const Header = (): JSX.Element => {
  const { displayedUrineCulture, isLoading, filterUrineCulturePerRangeOfDates, setOpenModalCompareUrineCulture } =
    useLaboratoryHealthProcedures()

  const handlePeriodDates = useCallback(
    (dates: Date[]): void => {
      const hasCompletelyRangeOfDates = dates.length !== 1

      if (hasCompletelyRangeOfDates) {
        filterUrineCulturePerRangeOfDates(dates)
      }
    },
    [filterUrineCulturePerRangeOfDates]
  )

  return (
    <Container>
      <Inline spacing="20px" width="100%" flexWrap="wrap" justifyContent="space-between">
        <Inline>
          <MedicalViewSelector selectedMedicalView={EMedicalViews.LABORATORY} isActive />
          <CalendarFilter isActive={false} onChange={handlePeriodDates} />
        </Inline>

        <Inline>
          <FilterByOrganisms />
          <CompareUrineCulture
            disabled={displayedUrineCulture?.length <= 0}
            isLoading={isLoading}
            onClick={() => setOpenModalCompareUrineCulture(true)}
          />
        </Inline>
      </Inline>
    </Container>
  )
}
